import React, { FC, useCallback, useEffect, useRef, useState } from "react";
import { Button, Input, InputRef } from "antd";
import "./ValueInput.scss";
import { UserProfileState } from "../../../index";
import { useTranslation } from "react-i18next";

type Props = {
  value: string;
  name: keyof UserProfileState;
  handleBlur: (key: string, value: string) => void;
  disabled?: boolean;
};

const ValueInput: FC<Props> = ({
  value,
  name,
  handleBlur,
  disabled = false,
}) => {
  const [state, setState] = useState(value);
  const inputRef = useRef<InputRef>(null);

  const { t } = useTranslation("personalPage", {
    keyPrefix: "userSettings.userInfo",
  });

  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isEditing]);

  const handleEditingClick = useCallback(() => {
    if (disabled) {
      return;
    }

    setIsEditing((prevState) => !prevState);
  }, [disabled]);

  const onBlur = useCallback(() => {
    if (state !== value) {
      handleBlur(name, state);
    }

    setIsEditing(false);
  }, [name, state, value, handleBlur]);

  if (isEditing) {
    return (
      <div className="value-input__container">
        <Input
          ref={inputRef}
          name={name}
          value={state}
          onChange={(event) => setState(event.target.value)}
          onBlur={onBlur}
          onPressEnter={onBlur}
          autoComplete="off"
        />
      </div>
    );
  }

  return (
    <div className="value-input__container">
      <label>{value}</label>
      <Button disabled={disabled} type="link" onClick={handleEditingClick}>
        {t("changeButton")}
      </Button>
    </div>
  );
};

export default ValueInput;
